import { render, staticRenderFns } from "./ProductPrizeView.vue?vue&type=template&id=a231771e&scoped=true"
import script from "./ProductPrizeView.vue?vue&type=script&lang=js"
export * from "./ProductPrizeView.vue?vue&type=script&lang=js"
import style0 from "./ProductPrizeView.vue?vue&type=style&index=0&id=a231771e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a231771e",
  null
  
)

export default component.exports